import { makeStyles } from '@mui/styles';
import React from 'react';
import ReactJson from 'react-json-view';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import { setUserMadeInteraction, updateEntityData } from '../actions/runtime.actions';
import { getEntityData } from '../selectors/common.selectors';

const useStyles = makeStyles({
  mainContainer: {
    "& [class*='edit-cancel'] > svg": {
      height: '18px !important',
      width: '18px !important',
    },
    "& [class*='edit-check string-value'] > svg": {
      height: '18px !important',
      width: '18px !important',
    },
    "& [class*='click-to-edit-icon']": {
      verticalAlign: 'text-top !important',
    },
    "& [class*='data-type-label']": {
      fontSize: '12px !important',
    },
    "& [class*='copy-to-clipboard-container']": {
      verticalAlign: 'text-top !important',
    },
    "& [class*='copy-icon'] > svg": {
      height: '18px !important',
      width: '18px !important',
      marginRight: '5px !important',
    },
    "& [class*='click-to-edit-icon'] > svg": {
      height: '18px !important',
      width: '18px !important',
    },
    "& [class*='variable-value'] > div > textarea + div > div": {
      backgroundColor: 'red !important',
      display: 'none !important',
    },
  },
});

const SSDataCorrection = ({ id, formKey }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const translateString = useTranslation();

  const entityData = useFormSelector(getEntityData);

  const handleEdit = ({ updated_src }) => {
    dispatch(updateEntityData(updated_src, formKey));
    dispatch(setUserMadeInteraction(formKey));
  };

  return (
    <div
      ui-ta={getUITA('FormCtrl', 'SSDataCorrection')}
      data-ss-id={id}
      className={classes.mainContainer}
    >
      <ReactJson
        src={entityData}
        theme="rjv-default"
        collapsed={2}
        onEdit={handleEdit}
        validationMessage={translateString('Invalid JSON value')}
        displayDataTypes={false}
        sortKeys
        name={false}
      />
    </div>
  );
};

export default SSDataCorrection;
